import {
    IonButton,
    IonButtons,
    IonFooter,
    IonHeader,
    IonIcon,
    IonLabel,
    IonLoading,
    IonModal,
    IonSegment,
    IonSegmentButton,
    IonTitle,
    IonToolbar
} from "@ionic/react"
import { chevronBack } from "ionicons/icons";
import { MouseEventHandler, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { assignFormToProfile } from "../../../store/profileFormAssigned/actions/assignFormToProfile";
import { selectPreselectedFormsCount } from "../../../store/profileFormAssigned/selector/selectPreselectedFormsCount";
import { RootState } from "../../../store/rootReducer";
import { AssignFormSelected } from "./AssignFormSelected";
import { AssignFormSelector } from "./AssignFormSelector";

export const AssignFormToProfile =
    (props: {
        show: boolean;
        handleClose: MouseEventHandler<HTMLIonButtonElement> | undefined;
    }): JSX.Element => {
        const [selectorActive, setSelectorActive] = useState(true);
        const preselectedCount = useSelector(selectPreselectedFormsCount);
        const assignFormToProfileStatus = useSelector((state: RootState) => state.profileFormAssigned.assignFormToProfileStatus);
        const findFormProfileStatus = useSelector((state: RootState) => state.profileFormAssigned.findFormListByProfileStatus);
        const dispatch = useDispatch();

        const handleSave = () => {
            dispatch(assignFormToProfile());
        }

        return (
            <IonModal isOpen={props.show}>
                <IonHeader translucent>
                    <IonToolbar>
                        <IonButtons slot="start">
                            <IonButton onClick={props.handleClose}>
                                <IonIcon icon={chevronBack} />
                            </IonButton>
                        </IonButtons>
                        <IonButtons slot="end">
                            <IonButton onClick={handleSave}>Guardar</IonButton>
                        </IonButtons>
                        <IonTitle>Gestionar plantillas</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <IonSegment
                    value={selectorActive ? "disponibles" : "seleccionadas"}
                    color="secondary"
                    style={{ 
                        maxWidth: '100%', 
                        position: 'fixed', 
                        bottom: 0, 
                        left: 0, 
                        backgroundColor: 'white', 
                        zIndex: 1000 }}
                >
                    <IonSegmentButton value="disponibles" onClick={() => { setSelectorActive(true) }}>
                        <IonLabel>Disponibles</IonLabel>
                    </IonSegmentButton>
                    <IonSegmentButton value="seleccionados" onClick={() => { setSelectorActive(false) }}>
                        <IonLabel>Seleccionadas ({preselectedCount})</IonLabel>
                    </IonSegmentButton>
                </IonSegment>
                {selectorActive ? (
                    <AssignFormSelector />
                ) : (
                    <AssignFormSelected />
                )}
                <IonFooter style={{ height: '3rem' }} className="ion-no-border" />
                <IonLoading 
                isOpen={assignFormToProfileStatus === "pending" || findFormProfileStatus === "pending"} 
                message={"Asignando plantillas..."}/>
            </IonModal>
        );
    }